import makeStyles from '@mui/styles/makeStyles';
import { CHECKBOX_BORDER_COLOR } from 'utils/constants';

export const useStyles = makeStyles({
	checkbox: {
		color: CHECKBOX_BORDER_COLOR,
		padding: '0 10px',

		'&.Mui-disabled': {
			color: CHECKBOX_BORDER_COLOR,
		},
	},
});
